Dropzone.autoDiscover = false;

var dropzoneOptions = {
    dictDefaultMessage: lang['dictDefaultMessage'],
    dictFallbackMessage: lang['dictFallbackMessage'],
    dictFallbackText: lang['dictFallbackText'],
    dictFileTooBig: lang['dictFileTooBig'],
    dictInvalidFileType: lang['dictInvalidFileType'],
    dictResponseError: lang['dictResponseError'],
    dictCancelUpload: lang['dictCancelUpload'],
    dictUploadCanceled: lang['dictUploadCanceled'],
    dictCancelUploadConfirmation: lang['dictCancelUploadConfirmation'],
    dictRemoveFile: lang['dictRemoveFile'],
    dictMaxFilesExceeded: lang['dictMaxFilesExceeded'],
    paramName: 'file_id',
    acceptedFiles: 'image/jpg, image/jpeg, image/png',
    clickable: '.dz-clickable',
    addedfile: function(file) {

    },
    sending: function(file, xhr, form) {
        file.previewElement = Dropzone.createElement(this.options.previewTemplate);
        $('.file-uploader__preview').html(file.previewElement);

        $('.file-uploader__new').hide();
        $('.file-uploader__error').html('').hide();
        form.append('csrf_token', token);
        form.append('reference', $('input[name="reference"]').val());
        form.append('reference_id', $('input[name="reference_id"]').val());
        form.append('parent_id', $('input[name="parent_id"]').val());
    },
    success: function(file, resp) {

        if(resp.success) {
            $('input[name="file_id"]').val(resp.file_id);
            $('.dz-progress').hide();

            $('.file-uploader__existing .dz-view')[0]._tippy.setContent("<img src='/admin/_img/" + resp.file_id + "/500' alt='" + resp.file_name + "' style='max-width: 100%;' />");

            $('.file-uploader__thumbnail').css('background-image', 'url(\'/admin/_img/' + resp.file_id + '/500\')');

            $('.file-uploader__existing').show();
            unsaved = true;

        } else {
            $('.dz-progress').hide();
            $('.file-uploader__new').show();
            $('.file-uploader__existing').hide();
            $('.file-uploader__error').html(resp.message).show();
        }

    },
    error: function(file, error) {
        $('.file-uploader__error').html(error).show();
    },
    previewTemplate: '<div class="dz-preview dz-file-preview">\n' +
        '  <div class="file-uploader__thumbnail"></div>\n' +
        '  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n' +
        '</div>'
};
